// Self-hosted variable fonts, imported here rather than from application.css:
// Tailwind inlines a CSS `@import` without rebasing it, which leaves the
// `url(./files/*.woff2)` references pointing at the built stylesheet's own
// directory. Importing them as JS modules lets Vite rewrite and emit them.
// Each family declares every unicode subset, so a page only downloads the
// latin file it actually needs.
import '@fontsource-variable/geist/index.css'
import '@fontsource-variable/geist-mono/index.css'
import '@fontsource-variable/archivo/standard.css'

import './application.css'
import '../images/background.svg'

import { Turbo } from '@hotwired/turbo-rails'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import * as ActiveStorage from '@rails/activestorage'
import { application } from 'controllers/application'
import { registerControllers } from 'stimulus-vite-helpers'
import { handleForbiddenFetchResponse } from '../lib/forbidden_response'

Turbo.start()

// app/views/shared/_notifications.html.erb sets these same options before it
// renders a Rails flash. Setting them here as well means a toast raised by a
// React page looks identical on a page that carries no flash message.
toastr.options = {
  closeButton: true,
  progressBar: true,
  positionClass: 'toast-top-right',
}
window.toastr = toastr

window.ActiveStorage = ActiveStorage
ActiveStorage.start()

// Auto-register Stimulus controllers with eager glob + helper (adds stable identifiers + HMR safety)
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// A 403 response never redirects (see ApplicationController#render_forbidden)
// - it comes back in place with an X-Toast-Message header. This stops Turbo
// from visiting/rendering it and shows that message as a toast instead, so
// the current page is left exactly as it was.
document.addEventListener('turbo:before-fetch-response', handleForbiddenFetchResponse)

// Handle dark mode on Turbo navigations
document.addEventListener('turbo:before-render', (event) => {
  const hasCookie = document.cookie.includes('dark_mode=')
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const isDark = hasCookie ? document.cookie.includes('dark_mode=true') : prefersDark
  event.detail.newBody.classList.toggle('dark', isDark)
  document.documentElement.classList.toggle('dark', isDark)
})
